import { zafClient } from '@/services/zendesk'
import type { VtexOrder, ZafMetadata, JadlogResponse } from '@/interfaces'

const JADLOG_CNPJ_REMETENTE = '18565468001241'

export async function getJadlogTracking(order: VtexOrder): Promise<JadlogResponse> {
  if (!zafClient) throw new Error('ZAF client not available')

  const meta = await zafClient.metadata() as unknown as ZafMetadata
  const { jadlogToken } = meta.settings

  if (!jadlogToken) throw new Error('Jadlog token não configurado')

  const danfe = order.packageAttachment.packages[0]?.invoiceKey
  if (!danfe) throw new Error('Invoice key não encontrado no pedido')

  const body = {
    consulta: [
      {
        df: {
          danfe,
          cnpjRemetente: JADLOG_CNPJ_REMETENTE,
          tpDocumento: 1,
        },
      },
    ],
  }

  const response = await zafClient.request({
    url: 'https://prd-traffic.jadlogtech.com.br/embarcador/api/tracking/consultar',
    type: 'POST',
    headers: {
      Authorization: `Bearer ${jadlogToken}`,
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(body),
    dataType: 'json',
    contentType: 'application/json',
  }) as JadlogResponse

  return response
}
